import { render } from "./PrivacyPolicyText.vue?vue&type=template&id=105ffd20&scoped=true"
import script from "./PrivacyPolicyText.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyText.vue?vue&type=script&lang=js"

import "./PrivacyPolicyText.vue?vue&type=style&index=0&id=105ffd20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105ffd20"]])

export default __exports__